import "./bootstrap";

import i18n from "@/scripts/i18n";
import Guest from "@/views/Layouts/GuestLayout";
import { createInertiaApp, router } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { createRoot } from "react-dom/client";
import ReactGA from "react-ga4";
import TurnstileProvider from "./Turnstile";
import { getCookie } from "./Utils/cookies";

function getConsent() {
  const cookie = getCookie("cookie_consent");
  if (!cookie) return null;
  try {
    if (cookie === "true")
      return { necessary: true, functional: true, analytics: true };
    if (cookie === "false")
      return { necessary: true, functional: false, analytics: false };
    return JSON.parse(cookie);
  } catch {
    return null;
  }
}

createInertiaApp({
  resolve: (name) => {
    return resolvePageComponent(
      `../views/Pages/${name}.tsx`,
      import.meta.glob("../views/Pages/**/*.tsx", { eager: false })
    ).then((module) => {
      // @ts-expect-error
      const component = module.default;
      component.layout =
        component.layout ||
        ((page) => <Guest children={page} title="Cohen Cars" />);
      return module;
    });
    // const pages = import.meta.glob("../views/Pages/**/*.tsx", {
    //   eager: true,
    // });
    // let page: any = pages[`../views/Pages/${name}.tsx`];

    // if (page && page.default) {
    //   page.default.layout =
    //     page.default?.layout ||
    //     ((page: any) => <Guest children={page} title="Test" />);
    // }
    // return page;
  },
  setup({ el, App, props }) {
    const root = createRoot(el);
    const locale = (props.initialPage.props.locale as string) || "en";
    const trackingId = import.meta.env.VITE_GA_ID;
    const consent = getConsent();

    if (locale) {
      (window as any).axios.defaults.headers.common["X-LOCALE"] = locale;
    }
    if (trackingId && consent?.analytics) {
      ReactGA.initialize(trackingId, {
        gtagOptions: {
          send_page_view: false, // Ensure automatic tracking is disabled
        },
      });
      console.log("Tracking PRE", window.location.pathname);

      // Track initial pageview
      ReactGA.send({
        hitType: "pageview",
        page: window.location.pathname,
        location: window.location.href,
        title: document.title,
      });

      // Use 'success' event instead of 'navigate' to ensure single tracking
      router.on("success", () => {
        console.log("Tracking", window.location.pathname);
        ReactGA.send({
          hitType: "pageview",
          page: window.location.pathname,
          location: window.location.href,
          title: document.title,
        });
      });
    }
    console.log("Locale", locale);

    i18n.changeLanguage(locale);

    return root.render(
      <TurnstileProvider siteKey={import.meta.env.VITE_CAPTCHA_PUBLIC}>
        <App {...props} />
      </TurnstileProvider>
    );
  },
});
